import moment from "moment";
import { IHoatDongHangNgayReducer } from "../../page-state-model/danh-gia/IHoatDongHangNgayReducer";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IHoatDongHangNgayActions } from "../../action-types/diem-danh/IHoatDongHangNgayActionType";
import { IHoatDongHangNgayRespone } from "../../../models/response/danh-gia/IHoatDongHangNgayRespone";

const iniState: IHoatDongHangNgayReducer = {
    status: ePageBaseStatus.is_not_initialization,
    request: {
        ngay: moment().format("YYYY-MM-DD"),
        dm_lop_id: 0
    },
    isOpenDiemDanh: false,
    isOpenNhanXetNhanh: false,
    donTreModal: {
        isOpen: false,
        hocSinhId: 0,
        diemDanh: undefined
    },
    traTreModal: {
        isOpen: false,
        hocSinhId: 0,
        diemDanh: undefined
    }
}
export const hoatDongHangNgayReducer = (state: IHoatDongHangNgayReducer = iniState, action: IHoatDongHangNgayActions): IHoatDongHangNgayReducer => {
    switch (action.type) {
        case "HOAT_DONG_HANG_NGAY_CHANGE_FILTER":
            return {
                ...state,
                request: action.payload,
                status: ePageBaseStatus.is_need_reload
            }
        case "HOAT_DONG_HANG_NGAY_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "HOAT_DONG_HANG_NGAY_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                data: action.payload
            }
        case "HOAT_DONG_HANG_NGAY_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        case "HOAT_DONG_HANG_NGAY_SHOW_DIEM_DANH_MODAL":
            return {
                ...state,
                isOpenDiemDanh: action.payload
            }
        case "HOAT_DONG_HANG_NGAY_SUBMIT_DIEM_DANH_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "HOAT_DONG_HANG_NGAY_SUBMIT_DIEM_DANH_SUCCESS":
            const newDiemDanhs = [...(state.data?.diemDanhs ?? [])]
            action.payload.forEach(p => {
                const idx = newDiemDanhs.findIndex(d => d.ts_hocsinh_id === p.ts_hocsinh_id)
                if (idx >= 0) {
                    newDiemDanhs[idx] = p;
                } else {
                    newDiemDanhs.push(p)
                }
            })
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                data: {
                    ...(state.data ?? {} as IHoatDongHangNgayRespone),
                    diemDanhs: newDiemDanhs
                },
                donTreModal: {
                    ...state.donTreModal,
                    isOpen: false
                },
                traTreModal: {
                    ...state.traTreModal,
                    isOpen: false
                }
                // isOpenDiemDanh:false
            }
        case "HOAT_DONG_HANG_NGAY_SUBMIT_DIEM_DANH_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        case "HOAT_DONG_HANG_NGAY_SUBMIT_NHAN_XET_LOP_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "HOAT_DONG_HANG_NGAY_SUBMIT_NHAN_XET_LOP_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                data: {
                    ...(state.data ?? {} as IHoatDongHangNgayRespone),
                    nhanXetChung: action.payload
                },
            }
        case "HOAT_DONG_HANG_NGAY_SUBMIT_NHAN_XET_LOP_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        case "HOAT_DONG_HANG_NGAY_SUBMIT_NHAN_XET_HOC_SINH_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "HOAT_DONG_HANG_NGAY_SUBMIT_NHAN_XET_HOC_SINH_SUCCESS":
            const newNhanXetHocSinhs = [...(state.data?.nhanXetHocSinh ?? [])]
            action.payload.forEach(p => {
                const idx = newNhanXetHocSinhs.findIndex(d => d.ts_hocsinh_id === p.ts_hocsinh_id
                    && d.sis_sonhanxet_item_id === p.sis_sonhanxet_item_id)
                if (idx >= 0) {
                    newNhanXetHocSinhs[idx] = p;
                } else {
                    newNhanXetHocSinhs.push(p)
                }
            })
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                data: {
                    ...(state.data ?? {} as IHoatDongHangNgayRespone),
                    nhanXetHocSinh: newNhanXetHocSinhs
                },
                // isOpenDiemDanh:false
            }
        case "HOAT_DONG_HANG_NGAY_SUBMIT_NHAN_XET_HOC_SINH_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        case "HOAT_DONG_HANG_NGAY_CHANGE_DON_TRE_MODAL":
            return {
                ...state,
                donTreModal: {
                    ...action.payload
                }
            }
        case "HOAT_DONG_HANG_NGAY_CHANGE_TRA_TRE_MODAL":
            return {
                ...state,
                traTreModal: {
                    ...action.payload
                }
            }
        case "HOAT_DONG_HANG_NGAY_SHOW_NHAN_XET_MODAL":
            return {
                ...state,
                isOpenNhanXetNhanh: action.payload
            }
        default:
            return state;
    }
}